import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import LandingPage from './pages/LandingPage';
import ValidatorPage from './pages/ValidatorPage';
import './App.css';

function App() {
  return (
    <div className="App">
      <Navigation />
  <main className="main-content">
        <Routes>
      <Route path="/" element={<LandingPage />} />
          <Route path="/validator" element={<ValidatorPage />} />
    </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
